import $ from 'jquery';

const focusOuline = () => {
  $(document).on('keyup', e => {
    if (e.key === 'Tab') {
      $('html').removeClass('no-focus-outline');
    }
  });
};

export default focusOuline();



// WEBPACK FOOTER //
// ./src/scripts/modules/no-focus-outline.js